import {
  defaultProjectsOverviewFilterDocument,
  goalListFilters,
  goalListSortOptions,
  projectListGroupOptions,
} from '@griply/utils';
import {
  useProjectsOverviewFilterDocument,
  useUpdateProjectsOverviewFilterDocument,
} from 'features/user';
import React from 'react';
import { ProjectsFilterButton } from 'shared/components/connected/projects-filter-button';

export const ProjectsOverviewFilterButton: React.FC = () => {
  const filterDocument = useProjectsOverviewFilterDocument();
  const updateFilterDocument = useUpdateProjectsOverviewFilterDocument();

  const onReset = () => updateFilterDocument({ filters: null });

  return (
    <ProjectsFilterButton
      filterDocument={filterDocument}
      defaultFilterDocument={defaultProjectsOverviewFilterDocument}
      updateFilterDocument={updateFilterDocument}
      onReset={onReset}
      supportedGroupByModes={[...projectListGroupOptions]}
      supportedFilters={[...goalListFilters]}
      supportedSortingModes={[...goalListSortOptions]}
    />
  );
};
